
    import './styles.scoped.css';
    export default {
  "button": "awsui_button_m5h9f_f4bpv_145",
  "expanded": "awsui_expanded_m5h9f_f4bpv_197",
  "offset-right-none": "awsui_offset-right-none_m5h9f_f4bpv_208",
  "offset-right-l": "awsui_offset-right-l_m5h9f_f4bpv_211",
  "offset-right-xxl": "awsui_offset-right-xxl_m5h9f_f4bpv_214",
  "text": "awsui_text_m5h9f_f4bpv_239",
  "icon": "awsui_icon_m5h9f_f4bpv_243"
};
  